import React from "react";
import {css, useTheme} from "@emotion/react";

import {calculateRemSize, flex, flexDirection, mb, mt, w100} from "@pg-design/helpers-css";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {form, IFormProps, IFormValuesAction} from "@pg-mono/form";

import {GTMEvent, PreferencesAction} from "../analytics/events";
import {additionalAreasCheckboxes, floorsCheckboxes, kitchenCheckboxes} from "../constants/configurator_checkboxes_lists";
import {usePropertyConfiguratorFiltersAnalytics} from "../hooks/use_property_configurator_filters_analytics";
import {ISearchFiltersFormValues} from "../reducers/property_configurator_reducer";
import {handleFormChange} from "../utils/handle_form_change";
import {PropertyConfiguratorStep, SearchFormValuesType} from "../views/PropertyConfigurator";
import {ConfiguratorCheckboxes} from "./filters/ConfiguratorCheckboxes";
import {RoomFilter} from "./filters/RoomFilter";
import {WorldDirectionFilter} from "./filters/WorldDirectionFilter";
import {ActionButtons} from "./ActionButtons";
import {AreaFilter} from "./AreaFilter";

interface IOwnProps {
    handleTabChange: (value: PropertyConfiguratorStep, prev?: boolean) => void;
}

interface IProps extends IOwnProps, IFormProps<ISearchFiltersFormValues> {}

export const RoomsTabC = (props: IProps) => {
    const theme = useTheme();
    const {trackArea, trackRooms} = usePropertyConfiguratorFiltersAnalytics(GTMEvent.FLAT_CONFIG_MODAL);

    const handleChange = (value: Partial<SearchFormValuesType>) => {
        handleFormChange(
            value,
            props.onChange as (formValues: Partial<SearchFormValuesType>) => IFormValuesAction<SearchFormValuesType>,
            props.values as SearchFormValuesType
        );
    };

    const handleRoomChange = (value: Partial<SearchFormValuesType>) => {
        handleChange(value);

        trackRooms(value);
    };

    const handleTabChange = (value: PropertyConfiguratorStep, prev?: boolean) => {
        props.handleTabChange(value, prev);

        if (!prev) {
            trackArea(props.values);
        }
    };

    return (
        <>
            <Text variant="headline_4" mb="1.6rem">
                Pomieszczenia i piętro
            </Text>
            <Text variant="body_copy_1" mb="3.2rem">
                Określ, jakie pomieszczenia ma mieć Twoje mieszkanie. Mieszkania na południe i zachód są przeważnie lepiej nasłonecznione.
            </Text>
            <div css={inputsWrapper}>
                <RoomFilter values={props.values} onChange={handleRoomChange} singleChoice />
                <AreaFilter values={props.values} onChange={props.onChange} />
            </div>

            <ConfiguratorCheckboxes
                checkboxList={additionalAreasCheckboxes()}
                header="Powierzchnie dodatkowe"
                gtmAction={PreferencesAction.ADDITIONAL_SPACES}
            />

            <ConfiguratorCheckboxes checkboxList={kitchenCheckboxes()} header="Kuchnia" gtmAction={PreferencesAction.KITCHEN_TYPE} />

            <Text color={getThemeVariable("colors.gray.700")} css={mb(1)} variant="body_copy_0">
                Piętro
            </Text>
            <div css={lastFiltersWrapper}>
                <ConfiguratorCheckboxes checkboxList={floorsCheckboxes()} gtmAction={PreferencesAction.FLOOR} checkboxesWrapperClassName="checkboxesStyle" />

                <div css={[flex("center"), flexDirection("column")]}>
                    <Text variant="body_copy_1" color={theme.colors.gray[700]} css={worldDirectionText}>
                        Strona świata
                    </Text>
                    <WorldDirectionFilter values={props.values} onChange={props.onChange} />
                </div>
            </div>

            <ActionButtons
                handleTabChange={handleTabChange}
                nextTab={{
                    label: "Przejdź dalej",
                    value: PropertyConfiguratorStep.BUDGET
                }}
                prevTab={{
                    label: "Powróć",
                    value: PropertyConfiguratorStep.LOCATION
                }}
                currentTab={PropertyConfiguratorStep.ROOMS}
            />
        </>
    );
};

export const RoomsTab = form<ISearchFiltersFormValues, IProps>(RoomsTabC);

const inputsWrapper = css`
    ${flex("flex-start")};
    gap: ${calculateRemSize(4)};
    ${w100};
    ${mb(7)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${mb(0)};
    }

    @media (max-width: ${getThemeBreakpoint().xs}) {
        ${flexDirection("column")};
    }
`;

const lastFiltersWrapper = css`
    ${w100};
    display: flex;
    align-items: start;
    ${mt(2)};
    ${mb(7)};
    gap: ${calculateRemSize(1)};

    > div {
        width: 50%;
    }
    .checkboxesStyle {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: normal;
        width: 100%;
        gap: ${calculateRemSize(1)};
        ${mb(0)};

        @media (min-width: ${getThemeBreakpoint().md}) {
            gap: ${calculateRemSize(3)};
        }
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        gap: ${calculateRemSize(3)};
    }

    @media (max-width: ${getThemeBreakpoint().md}) {
        ${flexDirection("column")}
        > div {
            width: 100%;
        }
    }
`;

const worldDirectionText = css`
    ${mb(2)};
    align-self: flex-start;
    ${mt(7)}

    @media (min-width: ${getThemeBreakpoint().md}) {
        align-self: initial;
        ${mt(0)};
    }
`;
import React from "react";
import {css, useTheme} from "@emotion/react";

import {calculateRemSize, flex, flexDirection, mb, mt, w100} from "@pg-design/helpers-css";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {form, IFormProps, IFormValuesAction} from "@pg-mono/form";

import {GTMEvent, PreferencesAction} from "../analytics/events";
import {additionalAreasCheckboxes, floorsCheckboxes, kitchenCheckboxes} from "../constants/configurator_checkboxes_lists";
import {usePropertyConfiguratorFiltersAnalytics} from "../hooks/use_property_configurator_filters_analytics";
import {ISearchFiltersFormValues} from "../reducers/property_configurator_reducer";
import {handleFormChange} from "../utils/handle_form_change";
import {PropertyConfiguratorStep, SearchFormValuesType} from "../views/PropertyConfigurator";
import {ConfiguratorCheckboxes} from "./filters/ConfiguratorCheckboxes";
import {RoomFilter} from "./filters/RoomFilter";
import {WorldDirectionFilter} from "./filters/WorldDirectionFilter";
import {ActionButtons} from "./ActionButtons";
import {AreaFilter} from "./AreaFilter";

interface IOwnProps {
    handleTabChange: (value: PropertyConfiguratorStep, prev?: boolean) => void;
}

interface IProps extends IOwnProps, IFormProps<ISearchFiltersFormValues> {}

export const RoomsTabC = (props: IProps) => {
    const theme = useTheme();
    const {trackArea, trackRooms} = usePropertyConfiguratorFiltersAnalytics(GTMEvent.FLAT_CONFIG_MODAL);

    const handleChange = (value: Partial<SearchFormValuesType>) => {
        handleFormChange(
            value,
            props.onChange as (formValues: Partial<SearchFormValuesType>) => IFormValuesAction<SearchFormValuesType>,
            props.values as SearchFormValuesType
        );
    };

    const handleRoomChange = (value: Partial<SearchFormValuesType>) => {
        handleChange(value);

        trackRooms(value);
    };

    const handleTabChange = (value: PropertyConfiguratorStep, prev?: boolean) => {
        props.handleTabChange(value, prev);

        if (!prev) {
            trackArea(props.values);
        }
    };

    return (
        <>
            <Text variant="headline_4" mb="1.6rem">
                Pomieszczenia i piętro
            </Text>
            <Text variant="body_copy_1" mb="3.2rem">
                Określ, jakie pomieszczenia ma mieć Twoje mieszkanie. Mieszkania na południe i zachód są przeważnie lepiej nasłonecznione.
            </Text>
            <div css={inputsWrapper}>
                <RoomFilter values={props.values} onChange={handleRoomChange} singleChoice />
                <AreaFilter values={props.values} onChange={props.onChange} />
            </div>

            <ConfiguratorCheckboxes
                checkboxList={additionalAreasCheckboxes()}
                header="Powierzchnie dodatkowe"
                gtmAction={PreferencesAction.ADDITIONAL_SPACES}
            />

            <ConfiguratorCheckboxes checkboxList={kitchenCheckboxes()} header="Kuchnia" gtmAction={PreferencesAction.KITCHEN_TYPE} />

            <Text color={getThemeVariable("colors.gray.700")} css={mb(1)} variant="body_copy_0">
                Piętro
            </Text>
            <div css={lastFiltersWrapper}>
                <ConfiguratorCheckboxes checkboxList={floorsCheckboxes()} gtmAction={PreferencesAction.FLOOR} checkboxesWrapperClassName="checkboxesStyle" />

                <div css={[flex("center"), flexDirection("column")]}>
                    <Text variant="body_copy_1" color={theme.colors.gray[700]} css={worldDirectionText}>
                        Strona świata
                    </Text>
                    <WorldDirectionFilter values={props.values} onChange={props.onChange} />
                </div>
            </div>

            <ActionButtons
                handleTabChange={handleTabChange}
                nextTab={{
                    label: "Przejdź dalej",
                    value: PropertyConfiguratorStep.BUDGET
                }}
                prevTab={{
                    label: "Powróć",
                    value: PropertyConfiguratorStep.LOCATION
                }}
                currentTab={PropertyConfiguratorStep.ROOMS}
            />
        </>
    );
};

export const RoomsTab = form<ISearchFiltersFormValues, IProps>(RoomsTabC);

const inputsWrapper = css`
    ${flex("flex-start")};
    gap: ${calculateRemSize(4)};
    ${w100};
    ${mb(7)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${mb(0)};
    }

    @media (max-width: ${getThemeBreakpoint().xs}) {
        ${flexDirection("column")};
    }
`;

const lastFiltersWrapper = css`
    ${w100};
    display: flex;
    align-items: start;
    ${mt(2)};
    ${mb(7)};
    gap: ${calculateRemSize(1)};

    > div {
        width: 50%;
    }
    .checkboxesStyle {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: normal;
        width: 100%;
        gap: ${calculateRemSize(1)};
        ${mb(0)};

        @media (min-width: ${getThemeBreakpoint().md}) {
            gap: ${calculateRemSize(3)};
        }
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        gap: ${calculateRemSize(3)};
    }

    @media (max-width: ${getThemeBreakpoint().md}) {
        ${flexDirection("column")}
        > div {
            width: 100%;
        }
    }
`;

const worldDirectionText = css`
    ${mb(2)};
    align-self: flex-start;
    ${mt(7)}

    @media (min-width: ${getThemeBreakpoint().md}) {
        align-self: initial;
        ${mt(0)};
    }
`;
